"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultPageProps = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _cookieUtils = _interopRequireDefault(require("../utils/cookieUtils"));

var _queryString = _interopRequireDefault(require("query-string"));

var getDefaultPageProps = function getDefaultPageProps(config) {
  var campaignIds = {};

  if (typeof window !== 'undefined') {
    var queryParams = _queryString.default.parse(window.location.search);

    (0, _forEach2.default)(config.campaignKeys, function (campaignKey, campaignKeyInParam) {
      campaignIds[campaignKey] = (0, _get2.default)(queryParams, campaignKeyInParam) || _cookieUtils.default.getCookie(campaignKey);
    });
  }

  return campaignIds;
};

exports.getDefaultPageProps = getDefaultPageProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/analyticsDefaultProperties.js
// module id = 1829
// module chunks = 25